// frontend/src/pages/Calendario.jsx
import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import 'react-calendar/dist/Calendar.css';
import '../styles/Calendario.css';

const Calendario = () => {
  const { user, hasPermission } = useAuth();
  const [date, setDate] = useState(new Date());
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showDetalleModal, setShowDetalleModal] = useState(false);
  const [eventoSeleccionado, setEventoSeleccionado] = useState(null);
  const [instituciones, setInstituciones] = useState([]);
  const [filtroTipo, setFiltroTipo] = useState('todos');
  const [filtroInstitucion, setFiltroInstitucion] = useState('todos');
  const [formData, setFormData] = useState({
    titulo: '',
    descripcion: '',
    fecha: new Date().toISOString().split('T')[0],
    hora: '',
    fechaFin: '',
    tipo: 'evento',
    paraTodos: false,
    institucionId: '',
    color: '',
    recordatorio: {
      activo: false,
      diasAntes: 1
    }
  });

  const tiposEvento = [
    { id: 'todos', nombre: 'Todos', icon: '📅' },
    { id: 'vencimiento', nombre: 'Vencimientos', icon: '⚠️', color: '#dc3545' },
    { id: 'reunion', nombre: 'Reuniones', icon: '👥', color: '#28a745' },
    { id: 'capacitacion', nombre: 'Capacitaciones', icon: '📚', color: '#17a2b8' },
    { id: 'evento', nombre: 'Eventos', icon: '🎉', color: '#ffc107' }
  ];

  useEffect(() => {
    cargarEventos();
    if (hasPermission(['super_admin_jasp', 'admin_jasp'])) {
      cargarInstituciones();
    }
  }, [date, filtroTipo, filtroInstitucion]);

  const cargarEventos = async () => {
    try {
      setLoading(true);
      
      // Calcular primer y último día del mes
      const año = date.getFullYear();
      const mes = date.getMonth() + 1;
      
      const params = new URLSearchParams({
        mes: mes,
        año: año
      });

      if (filtroTipo !== 'todos') {
        params.append('tipo', filtroTipo);
      }

      if (filtroInstitucion !== 'todos' && hasPermission(['super_admin_jasp', 'admin_jasp'])) {
        params.append('institucionId', filtroInstitucion);
      }

      const response = await api.get(`/eventos?${params.toString()}`);
      
      if (response.data && response.data.data) {
        setEventos(response.data.data);
      } else {
        setEventos([]);
      }
    } catch (error) {
      console.error('Error al cargar eventos:', error);
      setEventos([]);
    } finally {
      setLoading(false);
    }
  };

  const cargarInstituciones = async () => {
    try {
      const response = await api.get('/instituciones');
      if (response.data && response.data.data) {
        setInstituciones(response.data.data);
      } else if (Array.isArray(response.data)) {
        setInstituciones(response.data);
      } else {
        setInstituciones([]);
      }
    } catch (error) {
      console.error('Error al cargar instituciones:', error);
      setInstituciones([]);
    }
  };

  const handleDateChange = (newDate) => {
    setDate(newDate);
  };

  const handleEventoClick = (evento) => {
    setEventoSeleccionado(evento);
    setShowDetalleModal(true);
  };

  const handleGuardarEvento = async (e) => {
    e.preventDefault();
    
    try {
      // Validar datos
      if (!formData.titulo) {
        alert('El título es obligatorio');
        return;
      }
      
      if (!formData.fecha) {
        alert('La fecha es obligatoria');
        return;
      }

      const eventoData = {
        titulo: formData.titulo,
        descripcion: formData.descripcion,
        fecha: formData.fecha,
        hora: formData.hora || null,
        fechaFin: formData.fechaFin || null,
        tipo: formData.tipo,
        paraTodos: formData.paraTodos,
        institucionId: formData.institucionId,
        color: formData.color,
        recordatorio: formData.recordatorio
      };

      if (eventoSeleccionado) {
        // Actualizar evento existente
        await api.put(`/eventos/${eventoSeleccionado._id}`, eventoData);
        alert('✅ Evento actualizado correctamente');
      } else {
        // Crear nuevo evento
        await api.post('/eventos', eventoData);
        alert('✅ Evento creado correctamente');
      }

      setShowModal(false);
      resetFormData();
      cargarEventos();
    } catch (error) {
      console.error('Error al guardar evento:', error);
      alert(error.response?.data?.msg || 'Error al guardar el evento');
    }
  };

  const handleEliminarEvento = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar este evento?')) {
      try {
        await api.delete(`/eventos/${id}`);
        alert('✅ Evento eliminado');
        setShowDetalleModal(false);
        cargarEventos();
      } catch (error) {
        console.error('Error al eliminar:', error);
        alert('Error al eliminar el evento');
      }
    }
  };

  const resetFormData = () => {
    setFormData({
      titulo: '',
      descripcion: '',
      fecha: new Date().toISOString().split('T')[0],
      hora: '',
      fechaFin: '',
      tipo: 'evento',
      paraTodos: false,
      institucionId: '',
      color: '',
      recordatorio: {
        activo: false,
        diasAntes: 1
      }
    });
    setEventoSeleccionado(null);
  };

  const abrirModalNuevo = () => {
    // Usar la fecha seleccionada en el calendario como predeterminada
    const fechaSeleccionada = date.toISOString().split('T')[0];
    setFormData(prev => ({
      ...prev,
      fecha: fechaSeleccionada
    }));
    setShowModal(true);
  };

  const abrirModalEditar = (evento) => {
    // Extraer hora de la fecha si existe
    const fechaEvento = new Date(evento.fecha);
    const tieneHora = fechaEvento.getHours() !== 12 || fechaEvento.getMinutes() !== 0;
    const horaStr = tieneHora ? `${String(fechaEvento.getHours()).padStart(2, '0')}:${String(fechaEvento.getMinutes()).padStart(2, '0')}` : '';
    
    setEventoSeleccionado(evento);
    setFormData({
      titulo: evento.titulo,
      descripcion: evento.descripcion || '',
      fecha: new Date(evento.fecha).toISOString().split('T')[0],
      hora: horaStr,
      fechaFin: evento.fechaFin ? new Date(evento.fechaFin).toISOString().split('T')[0] : '',
      tipo: evento.tipo,
      paraTodos: evento.paraTodos || false,
      institucionId: evento.institucionId?._id || '',
      color: evento.color || '',
      recordatorio: evento.recordatorio || { activo: false, diasAntes: 1 }
    });
    setShowModal(true);
    setShowDetalleModal(false);
  };

  const getEventosDelDia = (fecha) => {
    const fechaStr = fecha.toDateString();
    return eventos.filter(e => {
      try {
        const fechaEvento = new Date(e.fecha);
        return fechaEvento.toDateString() === fechaStr;
      } catch {
        return false;
      }
    });
  };

  const puedeCrearEventos = () => {
  return user?.role === 'super_admin_jasp' || user?.role === 'admin_jasp';
};

  const formatearHora = (fecha) => {
    const d = new Date(fecha);
    const horas = d.getHours();
    const minutos = d.getMinutes();
    
    // Si es mediodía (12:00) probablemente no se especificó hora
    if (horas === 12 && minutos === 0) {
      return 'Todo el día';
    }
    
    return d.toLocaleTimeString('es-MX', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: true
    });
  };

  return (
    <div className="calendario">
      <div className="calendario-header">
        <div>
          <h1>Calendario</h1>
          <p>Gestiona fechas importantes, vencimientos y eventos</p>
        </div>
        {puedeCrearEventos() && (
          <button className="btn-primary" onClick={abrirModalNuevo}>
            + Nuevo Evento
          </button>
        )}
      </div>

      {/* Filtros */}
      <div className="filtros-calendario">
        <div className="filtros-tipos">
          {tiposEvento.map(tipo => (
            <button
              key={tipo.id}
              className={`filtro-tipo-btn ${filtroTipo === tipo.id ? 'active' : ''}`}
              onClick={() => setFiltroTipo(tipo.id)}
              style={{ '--tipo-color': tipo.color }}
            >
              <span>{tipo.icon}</span>
              <span>{tipo.nombre}</span>
            </button>
          ))}
        </div>

        {hasPermission(['super_admin_jasp', 'admin_jasp']) && (
          <div className="filtro-institucion">
            <select
              value={filtroInstitucion}
              onChange={(e) => setFiltroInstitucion(e.target.value)}
              className="form-control"
            >
              <option value="todos">Todas las instituciones</option>
              {instituciones.map(inst => (
                <option key={inst._id} value={inst._id}>{inst.nombre}</option>
              ))}
            </select>
          </div>
        )}
      </div>

      {/* Calendario y eventos */}
      <div className="calendario-grid">
        <div className="calendario-card">
          <Calendar
            onChange={handleDateChange}
            value={date}
            tileContent={({ date, view }) => {
              if (view === 'month') {
                const eventosDelDia = getEventosDelDia(date);
                return eventosDelDia.length > 0 ? (
                  <div className="eventos-marcadores">
                    {eventosDelDia.slice(0, 3).map((e, i) => (
                      <span 
                        key={i} 
                        className="evento-marcador"
                        style={{ backgroundColor: e.color || obtenerColorPorTipo(e.tipo) }}
                        title={e.titulo}
                      />
                    ))}
                    {eventosDelDia.length > 3 && (
                      <span className="evento-mas">+{eventosDelDia.length - 3}</span>
                    )}
                  </div>
                ) : null;
              }
            }}
            tileClassName={({ date, view }) => {
              if (view === 'month') {
                const eventosDelDia = getEventosDelDia(date);
                return eventosDelDia.length > 0 ? 'has-eventos' : null;
              }
            }}
          />
        </div>

        <div className="eventos-dia-card">
          <h2>
            Eventos del {date.toLocaleDateString('es-MX', { 
              weekday: 'long', 
              day: 'numeric', 
              month: 'long' 
            })}
          </h2>
          
          <div className="eventos-lista">
            {loading ? (
              <p className="text-center">Cargando eventos...</p>
            ) : (
              getEventosDelDia(date).map(evento => (
                <div
                  key={evento._id}
                  className="evento-item-detalle"
                  onClick={() => handleEventoClick(evento)}
                  style={{ borderLeftColor: evento.color || obtenerColorPorTipo(evento.tipo) }}
                >
                  <div className="evento-hora">
                    {formatearHora(evento.fecha)}
                  </div>
                  <div className="evento-contenido">
                    <h3>{evento.titulo}</h3>
                    <p>{evento.descripcion}</p>
                    <div className="evento-metadata">
                      <span className={`badge ${evento.tipo}`}>
                        {tiposEvento.find(t => t.id === evento.tipo)?.icon} {evento.tipo}
                      </span>
                      {evento.institucionId && (
                        <span className="institucion">
                          🏢 {evento.institucionId.nombre}
                        </span>
                      )}
                      {evento.paraTodos && (
                        <span className="publico">🌍 Público</span>
                      )}
                    </div>
                  </div>
                </div>
              ))
            )}

            {!loading && getEventosDelDia(date).length === 0 && (
              <p className="no-eventos">No hay eventos programados para este día</p>
            )}
          </div>
        </div>
      </div>

      {/* Modal para crear/editar evento */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content modal-lg">
            <h2>{eventoSeleccionado ? 'Editar Evento' : 'Nuevo Evento'}</h2>
            
            <form onSubmit={handleGuardarEvento}>
              <div className="form-group">
                <label>Título *</label>
                <input
                  type="text"
                  value={formData.titulo}
                  onChange={(e) => setFormData({...formData, titulo: e.target.value})}
                  className="form-control"
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Fecha *</label>
                  <input
                    type="date"
                    value={formData.fecha}
                    onChange={(e) => setFormData({...formData, fecha: e.target.value})}
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Hora (opcional)</label>
                  <input
                    type="time"
                    value={formData.hora}
                    onChange={(e) => setFormData({...formData, hora: e.target.value})}
                    className="form-control"
                  />
                  <small className="text-muted">Deja vacío si es un evento de día completo</small>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Fecha fin (opcional)</label>
                  <input
                    type="date"
                    value={formData.fechaFin}
                    onChange={(e) => setFormData({...formData, fechaFin: e.target.value})}
                    className="form-control"
                    min={formData.fecha}
                  />
                </div>

                <div className="form-group">
                  <label>Tipo *</label>
                  <select
                    value={formData.tipo}
                    onChange={(e) => setFormData({...formData, tipo: e.target.value})}
                    className="form-control"
                    required
                  >
                    {tiposEvento.filter(t => t.id !== 'todos').map(tipo => (
                      <option key={tipo.id} value={tipo.id}>{tipo.nombre}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Color</label>
                  <input
                    type="color"
                    value={formData.color || obtenerColorPorTipo(formData.tipo)}
                    onChange={(e) => setFormData({...formData, color: e.target.value})}
                    className="form-control color-picker"
                  />
                </div>
              </div>

              {hasPermission(['super_admin_jasp', 'admin_jasp']) && (
                <div className="form-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={formData.paraTodos}
                      onChange={(e) => setFormData({...formData, paraTodos: e.target.checked})}
                    />
                    Evento público (visible para todos)
                  </label>
                </div>
              )}

              {!formData.paraTodos && hasPermission(['super_admin_jasp', 'admin_jasp']) && (
                <div className="form-group">
                  <label>Institución</label>
                  <select
                    value={formData.institucionId}
                    onChange={(e) => setFormData({...formData, institucionId: e.target.value})}
                    className="form-control"
                  >
                    <option value="">Selecciona una institución</option>
                    {instituciones.map(inst => (
                      <option key={inst._id} value={inst._id}>{inst.nombre}</option>
                    ))}
                  </select>
                </div>
              )}

              <div className="form-group">
                <label>Descripción</label>
                <textarea
                  value={formData.descripcion}
                  onChange={(e) => setFormData({...formData, descripcion: e.target.value})}
                  className="form-control"
                  rows="3"
                  placeholder="Descripción del evento"
                />
              </div>

              <div className="form-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={formData.recordatorio.activo}
                    onChange={(e) => setFormData({
                      ...formData, 
                      recordatorio: {...formData.recordatorio, activo: e.target.checked}
                    })}
                  />
                  Activar recordatorio
                </label>
              </div>

              {formData.recordatorio.activo && (
                <div className="form-group">
                  <label>Recordar con</label>
                  <select
                    value={formData.recordatorio.diasAntes}
                    onChange={(e) => setFormData({
                      ...formData,
                      recordatorio: {...formData.recordatorio, diasAntes: parseInt(e.target.value)}
                    })}
                    className="form-control"
                  >
                    <option value="1">1 día de anticipación</option>
                    <option value="2">2 días de anticipación</option>
                    <option value="3">3 días de anticipación</option>
                    <option value="7">1 semana de anticipación</option>
                  </select>
                </div>
              )}

              <div className="modal-actions">
                <button type="button" className="btn-secondary" onClick={() => setShowModal(false)}>
                  Cancelar
                </button>
                <button type="submit" className="btn-primary">
                  {eventoSeleccionado ? 'Actualizar' : 'Crear'} Evento
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de detalle del evento */}
      {showDetalleModal && eventoSeleccionado && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div 
              className="detalle-header"
              style={{ backgroundColor: eventoSeleccionado.color || obtenerColorPorTipo(eventoSeleccionado.tipo) }}
            >
              <h2>{eventoSeleccionado.titulo}</h2>
              <button className="close-btn" onClick={() => setShowDetalleModal(false)}>×</button>
            </div>

            <div className="detalle-body">
              <div className="detalle-info">
                <p>
                  <strong>📅 Fecha:</strong>{' '}
                  {new Date(eventoSeleccionado.fecha).toLocaleDateString('es-MX', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                  {formatearHora(eventoSeleccionado.fecha) !== 'Todo el día' && (
                    <span> a las {formatearHora(eventoSeleccionado.fecha)}</span>
                  )}
                </p>
                
                {eventoSeleccionado.fechaFin && (
                  <p>
                    <strong>⏱️ Hasta:</strong>{' '}
                    {new Date(eventoSeleccionado.fechaFin).toLocaleDateString('es-MX', {
                      weekday: 'long',
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </p>
                )}

                <p>
                  <strong>📋 Tipo:</strong>{' '}
                  <span className={`badge ${eventoSeleccionado.tipo}`}>
                    {tiposEvento.find(t => t.id === eventoSeleccionado.tipo)?.nombre}
                  </span>
                </p>

                {eventoSeleccionado.institucionId && (
                  <p>
                    <strong>🏢 Institución:</strong> {eventoSeleccionado.institucionId.nombre}
                  </p>
                )}

                {eventoSeleccionado.paraTodos && (
                  <p>
                    <strong>🌍 Visibilidad:</strong> Evento público
                  </p>
                )}

                {eventoSeleccionado.descripcion && (
                  <div className="detalle-descripcion">
                    <strong>📝 Descripción:</strong>
                    <p>{eventoSeleccionado.descripcion}</p>
                  </div>
                )}

                <p className="detalle-creado">
                  <small>Creado por: {eventoSeleccionado.creadoPor?.nombre}</small>
                </p>
              </div>

              <div className="detalle-actions">
              {puedeCrearEventos() && (
                <button 
                  className="btn-primary"
                  onClick={() => abrirModalEditar(eventoSeleccionado)}
                >
                  ✏️ Editar
                </button>
              )}
              
              {/* Solo super admin o quien creó el evento (si es admin) puede eliminar */}
              {(user?.role === 'super_admin_jasp' || 
                (user?.role === 'admin_jasp' && eventoSeleccionado.creadoPor?._id === user?.id)) && (
                <button 
                  className="btn-danger"
                  onClick={() => handleEliminarEvento(eventoSeleccionado._id)}
                >
                  🗑️ Eliminar
                </button>
              )}
            </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Función auxiliar para obtener color por tipo
const obtenerColorPorTipo = (tipo) => {
  const colores = {
    vencimiento: '#dc3545',
    reunion: '#28a745',
    capacitacion: '#17a2b8',
    evento: '#ffc107'
  };
  return colores[tipo] || '#6c757d';
};

export default Calendario;